module.exports = __webpack_public_path__ + "static/media/plus.b9ebe56e.svg";